// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"start_wrapper__hnR_9","main":"start_main__OJQEc","gradient":"start_gradient__yr5bU"};